import { useEffect, useState } from 'react';

export const useDetectScrollDirection = () => {
  const threshold = 10;
  const [isScrollingUp, setIsScrollingUp] = useState(false);

  const shouldUpdateScrollDirection = (currentScrollYPosition: number, previousScrollYPosition: number) => {
    const scrollDistance = Math.abs(currentScrollYPosition - previousScrollYPosition);
    return scrollDistance > threshold;
  };

  const getScrollDirection = (currentScrollYPosition: number, previousScrollYPosition: number) => {
    return currentScrollYPosition < previousScrollYPosition &&
      previousScrollYPosition > 0;
  };

  useEffect(() => {
    let previousScrollYPosition = window.scrollY;

    const updateScrollDirection = () => {
      const currentScrollYPosition = window.scrollY;

      if (!shouldUpdateScrollDirection(currentScrollYPosition, previousScrollYPosition)) {
        return;
      }

      const isUp = getScrollDirection(currentScrollYPosition, previousScrollYPosition);
      setIsScrollingUp(isUp);
      previousScrollYPosition = currentScrollYPosition;
    };

    const handleScroll = () => window.requestAnimationFrame(updateScrollDirection);

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return isScrollingUp;
};
